import { Skeleton } from "@adafia/ui";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getPublishedNotes } from "../../api/blogs";
import { stripMarkdown } from "../../utils/blogs/markdown";

export const BlogList = () => {
	const {
		data: posts,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["blogs"],
		queryFn: getPublishedNotes,
	});

	if (isLoading)
		return (
			<div className="blog-list">
				<h1 className="blog-list-title">Blogs_</h1>
				{[1, 2, 3].map((i) => (
					<div key={i} className="blog-item" style={{ pointerEvents: "none" }}>
						<Skeleton width="100px" height="1rem" />
						<Skeleton
							width="60%"
							height="2rem"
							style={{ margin: "0.5rem 0" }}
						/>
						<Skeleton width="100%" height="4rem" />
					</div>
				))}
			</div>
		);
	if (error) return <p>Error loading blog posts.</p>;

	return (
		<div className="blog-list">
			{posts?.map((post) => (
				<Link
					key={post.id}
					to={`/blog/${post.slug || post.id}`}
					className="blog-item"
				>
					<span className="blog-date">
						{post.publishedAt
							? new Date(post.publishedAt).toLocaleDateString("en-US", {
									month: "long",
									day: "numeric",
									year: "numeric",
								})
							: "Unpublished"}
					</span>
					<h2 className="blog-title">{post.title}</h2>
					<p className="blog-excerpt">
						{stripMarkdown(post.content || "").substring(0, 200)}...
					</p>
				</Link>
			))}
			{posts?.length === 0 && (
				<p className="blog-empty">No posts published yet.</p>
			)}
		</div>
	);
};
